import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { Card, CardContent, Grid, Button } from "@material-ui/core/";
import { withStyles } from "@material-ui/core/styles";
import LoginStyles from "./LoginStyles";
import { createLoginSchema } from "./Login-schema";
import { closeSnackBar } from "../../../reducers";
import Form from "./form";
import { loginAction, resetLoginErrors } from "../Auth.ducks";
import Cookies from 'universal-cookie';
import { ErrorSnackbar, SuccessSnackbar } from "../../../components/IntegratedSnackbars";
import { withTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/LanguageSwitcher';

import srcIconLogo from "../../../styles/img/logo-kiuono-white.svg";
const LogoLogin = () => <object data={srcIconLogo} type="image/svg+xml" className="img-fluid logo-login" />

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleCloseError = this.handleCloseError.bind(this)
    this.handleCloseSuccess = this.handleCloseSuccess.bind(this)
  }
  static propTypes = {
    loginAction: PropTypes.func,
    auth: PropTypes.object,
    classes: PropTypes.object
  };

  handleCloseError() {
    this.props.closeSnackBar("errorMsg")
  }
  handleCloseSuccess() {
    this.props.closeSnackBar("successMsg")
  }
  handleLogin = values => {
    this.props.loginAction(values);
  };

  render() {
    console.log('Login ',process.env.REACT_APP_NODE_ENV)
    const { t } = this.props;

    const {
      resetLoginErrors,
      classes: { root, formBtn },
      auth: { error }
    } = this.props;
    const displayHide = { display: "none" }
    const displayShow = { display: "block" }
    return (
      <div className="main-wrapper login-page">
        {this.props.successMsg.status ? <SuccessSnackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.props.successMsg.status}
          autoHideDuration={2000}
          onClose={this.handleCloseSuccess}
          variant="success"
          display={displayHide}
          message={this.props.successMsg.message}
        /> : ""}
        {this.props.errorMsg.status ? <ErrorSnackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.props.errorMsg.status}
          onClose={this.handleCloseError}
          autoHideDuration={5000}
          variant="error"
          display={displayShow}
          message={this.props.errorMsg.message}
        /> : ""}
        <div className="container-login">
          <div className="entete-login">
            <LogoLogin />
            <h1>{t('login.tagline')}</h1>
          </div>
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            <LanguageSwitcher />
          </div>
          <Formik
            initialValues={{ username: "", password: "" }}
            validationSchema={createLoginSchema(t)}
            onSubmit={(values, actions) => this.handleLogin(values)}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              setFieldValue,
              errors,
              touched
            }) => {
              return (
                <form onSubmit={handleSubmit} className="box-login">
                  <Form
                    setFieldValue={setFieldValue}
                    errors={errors}
                    errorLogin={error}
                    handleChange={handleChange}
                    values={values}
                    touched={touched}
                    resetLoginErrors={resetLoginErrors}
                  />
                  <a href="forgot-password" className="lost-pw">{t('login.forgot_password')}</a>
                  <button type="submit"
                    onClick={handleSubmit} className="btn-gradient mt-4">{t('login.submit')}</button>

                </form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, successMsg, errorMsg }) => ({ auth, successMsg, errorMsg });

const mapDispatchToProps = { loginAction, resetLoginErrors, closeSnackBar };

const withStore = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withStyles(LoginStyles)(withTranslation()(withStore(Login)));
